import * as Yup from 'yup';
import { selectEnums, selectIsFetchingEnums } from '../../ducks/entities';
import { useEffect, useState } from 'react';
import SelectQuestion from '../SelectQuestion/SelectQuestion';
import { createOptions } from '../../utils/generic';
import messages from './messages';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

interface Props {
  values: any;
  errors: any;
  setFieldValue: any;
  updateSchema: (value: any) => void;
}

const Platforms = ({ values, errors, setFieldValue, updateSchema }: Props) => {
  const intl = useIntl();

  const [platformsOptions, setPlatformsOptions] = useState<any>();
  const enums = useSelector(selectEnums);
  const isFetchingEnums = useSelector(selectIsFetchingEnums);

  useEffect(() => {
    if (!isFetchingEnums && enums) {
      setPlatformsOptions(createOptions(enums.platforms));
    }
  }, [enums]);

  useEffect(() => {
    const platformsSchema = {
      platformIds: Yup.array(Yup.string()).min(
        1,
        intl.formatMessage({ ...siteMessages.FIELD_REQUIRED })
      )
    };
    updateSchema(platformsSchema);
  }, []);

  return (
    <SelectQuestion
      controlId="platformIds"
      label={intl.formatMessage({ ...messages.platforms })}
      isMulti={true}
      options={platformsOptions}
      value={values.platformIds}
      error={errors.platformIds}
      setFieldValue={setFieldValue}
    />
  );
};

export default Platforms;
